export default () => {
  const data = {
    event_name: 'click',
    button_name: 'send',
    page_section: 'doubt_section',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
